import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000/";

const HrKraManagement = () => {
  const [kraList, setKraList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showKraForm, setShowKraForm] = useState(false);
  const [showKraFilters, showKraFilter] = useState(true);

  const [editingKra, setEditingKra] = useState(null);
  const [userRole, setUserole] = useState([]);
  const [department, setDepdata] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);

  const token = JSON.parse(localStorage.getItem("key"));
  const [filters, setFilters] = useState({
    financial_year: "",
    role_id: "",
    status: "",
  });
  const [kraForm, setKraForm] = useState({
    financial_year: "2026-27",
    // department_id: "",
    role_id: "",
    // kra_code: "",
    kra_name: "",
    description: "",
    weightage: "",
  });

  useEffect(() => {
    loadKra();
    getUserRole();
    getDepartmentList();
  }, [currentPage, recordsPerPage, filters.financial_year, filters.role_id]);
  const getUserRole = () => {
    const response = fetch(API + `api/common/sytem-role`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUserole(data.result);
      });
  };
  const getDepartmentList = () => {
    const response = fetch(API + `api/common/department_list`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setDepdata(data?.result);
      });
  };

  const loadKra = async () => {
    try {
      const params = new URLSearchParams();

      // Pagination
      params.append("role", filters.role_id);
      params.append("financial_year", filters.financial_year);
      params.append("page", currentPage);
      params.append("pageSize", recordsPerPage);
      const res = await axios.get(
        `${API}api/Performance/kra/all?${params.toString()}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token.value}`,
          },
        },
      );
      console.log(res.data, "KRA LIST====================");
      if (res.data.success) {
        setKraList(res.data.data);
        setTotalRecords(Number(res.data.total || 0));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleKraChange = (e) => {
    setKraForm({
      ...kraForm,
      [e.target.name]: e.target.value,
    });
  };

  const submitKra = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.value}`,
        },
      };

      const data = {
        kraForm: kraForm,
      };
      if (editingKra) {
        await axios.put(
          `${API}api/Performance/kra/${editingKra.id}`,
          data,
          config,
        );

        alert("KRA updated successfully");
        setLoading(false);
      } else {
        await axios.post(`${API}api/Performance/kra`, data, config);

        alert("KRA created successfully");
        setLoading(false);
      }

      resetKra();

      loadKra();
    } catch (error) {
      console.error(error);

      alert(error.response?.data?.message || "Unable to save KRA");
      setLoading(false);
    }
  };

  const resetKra = () => {
    setKraForm({
      financial_year: "2026-27",
      // department_id: "",
      role_id: "",
      // kra_code: "",
      kra_name: "",
      description: "",
      weightage: "",
    });

    setEditingKra(null);
    setShowKraForm(false);
    showKraFilter(true);
    setCurrentPage(1);
  };
  const clearFilters = () => {
    setFilters({
      financial_year: "",
      role_id: "",
      status: "",
    });

    setCurrentPage(1);
  };

  const editKra = (item) => {
    setEditingKra(item);

    setKraForm({
      financial_year: item.financial_year,
      // department_id: item.department_id,
      role_id: item.role_id,
      // kra_code: item.kra_code,
      kra_name: item.kra_name,
      description: item.description || "",
      weightage: item.weightage,
    });
    showKraFilter(false);
    setShowKraForm(true);
    setTimeout(() => {
      document.getElementById("content_area")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };

  const deleteKra = async (id) => {
    if (!window.confirm("Delete this KRA and all associated KPI?")) {
      return;
    }

    try {
      await axios.delete(`${API}api/Performance/kra/${id}`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.value}`,
        },
      });

      loadKra();
      showKraFilter(true);
      setCurrentPage(1);
    } catch (error) {
      console.error(error);
    }
  };
  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  const startIndex =
    totalRecords === 0 ? 0 : (currentPage - 1) * recordsPerPage;

  const endIndex = Math.min(currentPage * recordsPerPage, totalRecords);
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      setCurrentPage(page);
    }
  };
  const getPageNumbers = () => {
    const pages = [];

    // No pages
    if (totalPages <= 0) {
      return pages;
    }

    // 1 - 5 pages
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }

      return pages;
    }

    // Current page near beginning
    if (currentPage <= 3) {
      pages.push(1, 2, 3, 4, "...", totalPages);

      return pages;
    }

    // Current page near end
    if (currentPage >= totalPages - 2) {
      pages.push(
        1,
        "...",
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      );

      return pages;
    }

    // Current page in middle
    pages.push(
      1,
      "...",
      currentPage - 1,
      currentPage,
      currentPage + 1,
      "...",
      totalPages,
    );

    return pages;
  };

  return (
    <>
      <div className="page-header">
        <h1>
          KRA Management
          <button
            type="button"
            className="btn btn-sm btn-info mr08 float-end"
            onClick={() => {
              resetKra();
              setShowKraForm(true);
              showKraFilter(false);
            }}
          >
            + Add KRA
          </button>
        </h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to="/dashboard">Dashboard </Link>
          </li>
          <li>
            <Link to="/employeelist">
              <span>/</span>KRA Management{" "}
            </Link>
          </li>
          <li className="current">
            <span>/</span>Master
          </li>
        </ul>
      </div>
      <div className="row_bg">
        {showKraForm && (
          <div className="dash_white_box2 mb10 p10">
            <strong>{editingKra ? "Edit KRA" : "Add KRA"}</strong>
            <div className="row mb30">
              <form onSubmit={submitKra}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3 mb-3">
                      <label>Financial Year</label>

                      <select
                        className="form-select"
                        name="financial_year"
                        value={kraForm.financial_year}
                        onChange={handleKraChange}
                      >
                        <option value="2025-26">2025-26</option>

                        <option value="2026-27">2026-27</option>

                        <option value="2027-28">2027-28</option>
                      </select>
                    </div>

                    {/* <div className="col-md-3 mb-3">
                  <label>Department</label>

                  <select
                    className="form-select"
                    name="department_id"
                    value={kraForm.department_id}
                    onChange={handleKraChange}
                    required
                  >
                    <option value="">Select Department</option>

                    {department?.map((item, ind) => (
                      <option key={ind} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div> */}

                    <div className="col-md-2 mb-3">
                      <label>Categories</label>
                      <select
                        className="form-select"
                        name="role_id"
                        value={kraForm.role_id}
                        onChange={handleKraChange}
                        required
                      >
                        <option value="">Select Categories</option>
                        {userRole?.map((item, ind) => (
                          <option key={ind} value={item.id}>
                            {item.role}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>KRA Name</label>

                      <input
                        type="text"
                        className="form-control"
                        name="kra_name"
                        value={kraForm.kra_name}
                        onChange={handleKraChange}
                        placeholder="KRA Name"
                        required
                      />
                    </div>
                    <div className="col-md-2 mb-3">
                      <label>Weightage %</label>

                      <input
                        type="number"
                        min="0"
                        max="100"
                        className="form-control"
                        name="weightage"
                        value={kraForm.weightage}
                        onChange={handleKraChange}
                      />
                    </div>

                    <div className="col-md-8 mb-3">
                      <label>Description</label>

                      <textarea
                        className="form-control"
                        rows="4"
                        name="description"
                        value={kraForm.description}
                        onChange={handleKraChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="card-footer">
                  <button
                    type="submit"
                    className="btn btn-sm btn-success mr08 float-end"
                  >
                    Save KRA
                  </button>

                  <button
                    type="button"
                    className="btn btn-sm btn-danger mr08 float-end"
                    onClick={resetKra}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        {showKraFilters && (
          <div className="dash_white_box2 mb10 p10">
            <label className="form-label">Search</label>
            <div className="row mb10">
              <div className="col-lg-3 col-md-6 pl07 pr07">
                <label className="form-label">Financial Year</label>
                <select
                  className="form-control"
                  value={filters.financial_year}
                  name="financial_year"
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      financial_year: e.target.value,
                    })
                  }
                >
                  <option value="">Select</option>
                  <option value="2025-26">2025-26</option>

                  <option value="2026-27">2026-27</option>

                  <option value="2027-28">2027-28</option>
                </select>
              </div>
              <div className="col-lg-3 col-md-6 pl07 pr07">
                <label className="form-label">Categories</label>
                <select
                  className="form-control"
                  value={filters.role_id}
                  name="role_id"
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      role_id: e.target.value,
                    })
                  }
                >
                  <option value="">Select</option>
                  {userRole?.map((item, ind) => (
                    <option key={ind} value={item.id}>
                      {item.role}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-lg-3 col-md-6 pl07 pr07">
                <label className="d-block mb30 pt07"></label>
                <button className="btn_6" onClick={clearFilters}>
                  Clear Filters
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="dash_white_box2 mb10 p20">
          <strong>KRA Master</strong>
          <div className="row mb30">
            <div className="col-md-12">
              <div className="table-responsive">
                <table className="table_style_1 table-bordered table-hover mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Financial Year</th>
                      {/* <th>Department</th> */}
                      <th>Categories</th>
                      <th>KRA</th>
                      <th>Weightage</th>
                      <th>KPI Count</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {kraList.length === 0 ? (
                      <tr>
                        <td colSpan="9" className="text-center">
                          No KRA found
                        </td>
                      </tr>
                    ) : (
                      kraList.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>

                          <td>{item.financial_year}</td>

                          {/* <td>{item.department_name}</td> */}

                          <td>
                            <strong>{item.system_role}</strong>
                          </td>

                          <td>{item.kra_name}</td>

                          <td>{item.weightage}%</td>

                          <td>
                            <span className="badge bg-info">
                              {item.kpi_count}
                            </span>
                          </td>

                          <td>
                            <span className="badge bg-success">
                              {item.status}
                            </span>
                          </td>

                          <td>
                            <button
                              className="btn_3 btn-sm btn-warning me-1"
                              onClick={() => editKra(item)}
                            >
                              Edit
                            </button>

                            <button
                              className="btn_2 btn-sm btn-danger"
                              onClick={() => deleteKra(item.id)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              {/* =================================================
              PAGINATION
              ================================================= */}

              {totalRecords > 0 && (
                <div className="pagination-wrapper">
                  {/* Pagination Info */}
                  <div className="pagination-info">
                    Showing <strong>{startIndex + 1}</strong> to{" "}
                    <strong>{endIndex}</strong> of{" "}
                    <strong>{totalRecords}</strong> entries
                  </div>

                  {/* Pagination */}
                  <div className="pagination">
                    {/* Previous */}
                    <button
                      disabled={currentPage === 1 || loading}
                      onClick={() => goToPage(currentPage - 1)}
                    >
                      <i className="bi bi-chevron-left">«</i>
                    </button>

                    {/* Page Numbers */}
                    {getPageNumbers().map((page, index) => {
                      if (page === "...") {
                        return (
                          <span
                            key={`dots-${index}`}
                            className="pagination-dots"
                          >
                            ...
                          </span>
                        );
                      }

                      return (
                        <button
                          key={page}
                          disabled={loading}
                          className={currentPage === page ? "active" : ""}
                          onClick={() => goToPage(page)}
                        >
                          {page}
                        </button>
                      );
                    })}

                    {/* Next */}
                    <button
                      disabled={currentPage === totalPages || loading}
                      onClick={() => goToPage(currentPage + 1)}
                    >
                      <i className="bi bi-chevron-right">»</i>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HrKraManagement;
